import { render, staticRenderFns } from "./AddWatercourseButton.vue?vue&type=template&id=1b2ef5d1&"
import script from "./AddWatercourseButton.vue?vue&type=script&lang=js&"
export * from "./AddWatercourseButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports